import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import usePushNotifications from '../hooks/usePushNotifications';


const Authenticated = ({ children }) => {
  const token = localStorage.getItem('accessToken')
  const navigate = useNavigate();

  usePushNotifications(!!token);

  useEffect(() => {
    if (!token) {
      navigate(`/`)
    }

  }, [token, navigate,]);

  return <>
    {children}</>;
};
export default Authenticated;